import {
  FulfillmentTypeGetV2ResponseType,
  FulfillmentTypeGetV2RequestType,
} from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptions,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useFulfillmentTypeGetV2 = <
  TData = FulfillmentTypeGetV2ResponseType,
>(
  params: FulfillmentTypeGetV2RequestType,
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [business?.id, ServerStateKeys.FulfillmentTypeV2, params],

    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `fulfillment-type/for-retailer`,
        params,
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptions(options),
  });
};
